import React, { Component } from 'react';
import "tabler-react/dist/Tabler.css";
import { Page, Card, Dimmer, Icon } from "tabler-react";

import GraficaMisCursos from "./GraficaMisCursos"
import TablaMisCursos from "./TablaMisCursos"
import TablaCurso from "./TablaCurso"

import  { API } from 'aws-amplify';
class MisCursos extends Component {
		/*Inicializamos todas las variables*/
		constructor (props) {
			super(props);
			this.state = {
				alumnosInfo: [],
				alumnosBloqueados: [],
				alumnosInfoEstatus: [],
				dataGraficaMisCursos: [],
				dataTablaMisCursos: [],
				dataTablaCurso: [],
				cursos: [],
				statusDataTablaCurso: false,
				titleCurso: "",
				loading: 'active',
				loadingTablaCurso: '',
				vistaGeneral: this.props.vistaGeneral !== undefined ? true : false,
				blackboard: JSON.parse(localStorage.getItem('blackboard'))
			};
		}

		//Inicializamos la informaicon de los docentes en el momento de iniciar a misCursos
		componentDidMount = () => {
			if (this.state.blackboard.isBlackboard === false) {
				this.getInfoDocente()
			} else {
				this.setState({ loading: '' })
			}
		}

		getInfoDocente = async () => {
			const docenteInfo = JSON.parse(localStorage.getItem('profile'));
			let alumnosData = [];
			let alumnosBloqueadosData = [];
			let alumnosMasterData = [];
			let cursosData = [];
			for(let nivel of docenteInfo.nivel) {

				const respuestaApiAlumnosBloqueados = await API.post('apiMisCursos', '/obtenerAlumnosMoodle', {
					body: {
						nivel: nivel,
						username: docenteInfo.username,
						tipo: "alumnosBloqueados"
					}
				});
				if (respuestaApiAlumnosBloqueados.status) {
					Array.prototype.push.apply(alumnosBloqueadosData, respuestaApiAlumnosBloqueados.data.alumnosBloqueados);
				}
				const respuestaApiAlumnos = await API.post('apiMisCursos', '/obtenerAlumnosMoodle', {
					body: {
						nivel: nivel,
						username: docenteInfo.username,
						tipo: "alumnos"
					}
				});
				if (respuestaApiAlumnos.status) {
					let alumnosNivelUrlFinal = [];
					for (const alumnosinfo of respuestaApiAlumnos.data.alumnos) {
						let detallesAlumnos = {}
						const alumnosConNivelUrl =  {  urlNivel: nivel }
						detallesAlumnos = Object.assign( alumnosinfo , alumnosConNivelUrl)
						alumnosNivelUrlFinal.push(detallesAlumnos)
					}
					Array.prototype.push.apply(alumnosData, alumnosNivelUrlFinal);					

					let alumnosMasterFinal = [];
					let usuarios = [];
					let matriculasFinal	= [];
					// let matriculasFinal = respuestaApiAlumnos.data.matriculas;;
					let filtroAlumnos = respuestaApiAlumnos.data.matriculas;
					let arregloDeArreglos = []; // Aquí almacenamos los nuevos arreglos
					for (const usernamesInfo of filtroAlumnos) {
						if(isNaN(usernamesInfo)) {
							usuarios.push(usernamesInfo)
						} else {
							matriculasFinal.push(usernamesInfo)
						}
					}
					
					const LONGITUD_PEDAZOS = 25; // Partir en arreglo de 3
					for (let i = 0; i < matriculasFinal.length; i += LONGITUD_PEDAZOS) {
						let pedazo = matriculasFinal.slice(i, i + LONGITUD_PEDAZOS);
						arregloDeArreglos.push(pedazo);
					}
					for (const arreglo of arregloDeArreglos) {
						const respuestaApiAlumnosMaster = await API.post('apiMisCursos', '/obtenerAlumnosMoodle', { body: { nivel: nivel, username: docenteInfo.username, tipo: "alumnosMaster", matriculas: arreglo }});
						if(respuestaApiAlumnosMaster.status) {
							let alumnosMaster = respuestaApiAlumnosMaster.data.alumnosMaster;
							for (const alumnosMasterInfo of alumnosMaster) {
								alumnosMasterFinal.push(alumnosMasterInfo) 
							}
						}
					}
					let alumnosMoodle = respuestaApiAlumnos.data.alumnos
					for (const usuariosMatricula of usuarios) {						
						for (const alumnosMoodleInfo of alumnosMoodle) {
							if(usuariosMatricula == alumnosMoodleInfo.matricula){
								alumnosMasterFinal.push({ estatus: alumnosMoodleInfo.grupoMoodle, matricula: alumnosMoodleInfo.matricula, nivel: "Onsite"})
							}
							
						}
					}
					Array.prototype.push.apply(alumnosMasterData, alumnosMasterFinal);

					const respuestaApiCursos = await API.post('apiMisCursos', '/obtenerAlumnosMoodle', {
						body: {
							nivel: nivel,
							username: docenteInfo.username,
							tipo: "cursos",
							cursoUnico: respuestaApiAlumnos.data.cursoUnico
						}
					});
					if (respuestaApiCursos.status) {
						Array.prototype.push.apply(cursosData, respuestaApiCursos.data.cursos);
					}
				}
			}
			let data = {alumnos: alumnosData, alumnosBloqueados: alumnosBloqueadosData, alumnosMaster: alumnosMasterData, cursos: cursosData };
			this.graficaMisCursos(data)
			this.tablaMisCursos(data)
			this.setState({ loading: '' })

		}

		getAlumnosInfo = (data) => {
			const alumnosInfo = []
			for (const alumnos of data.alumnos) {
				for (const alumnosMaster of data.alumnosMaster) {
					if(alumnos.matricula == alumnosMaster.matricula){
						let grupo = ''
						if( alumnos.nivel == 'onsite' ){
							if(isNaN(alumnos.matricula)) {
								grupo = alumnos.grupoMoodle
							} else {
								grupo = alumnos.grupo
							}							
						} else {
							grupo = alumnos.grupo
						}
						alumnosInfo.push({
							id: alumnos.id,
							apellidos: alumnos.apellidos,
							cursoNombre: alumnos.cursoNombre,
							email: alumnos.email, 
							grupo: grupo, 
							matricula: alumnos.matricula, 
							nombres: alumnos.nombres, 
							ultimoAcceso: this.getDateUnix(alumnos.ultimoAcceso),
							nivel: alumnosMaster.nivel, 
							estatus: alumnosMaster.estatus,
							urlNivel: alumnos.urlNivel 
						})
					}
				}
			}
			return alumnosInfo
		}

		graficaMisCursos = (data) => {
			const alumnosInfo = this.getAlumnosInfo(data)
			const alumnosEstatus = []
			alumnosEstatus.push('Bloqueados')
			for (const alumnos of alumnosInfo) {
				alumnosEstatus.push(alumnos.estatus)
			}
			const alumnosInfoEstatus = this.eliminaDuplicados(alumnosEstatus)
			
			const alumnosBloqueados = this.eliminaDuplicados(data.alumnosBloqueados)      
			
			const estatusInfo = []
			let cont = 0
			let contCursos = []
			const colores = { AN: "#56ebd3", BA: "#ba1a17", BC: "#37d356", A2: "#e76cef", EN: "#639f50", EA: "#732576", EC: "#bce333", E2: "#6029ce", EG: "#f1d438", BD: "#2f5bb1", ST: "#fd8f20", CN: "#075c62", CT: "#fd8992", CD: "#11a0aa", CR: "#ff0087", AR: "#096013", BR: "#fa1bfc", RC: "#c2dcb8", BO: "#6d3918", AM: "#c697f4", ED: "#474a09", EM: "#afc6fe", SP: "#b18b34", Bloqueados: "#0330A0" }
			for (const estatus of alumnosInfoEstatus) {
					contCursos = []
					for (const cursos of data.cursos) {
							cont = 0
							// contBloqueados = 0
							for (const infoAlumno of alumnosInfo) {
									if(estatus == infoAlumno.estatus && cursos.cursosNombres == infoAlumno.cursoNombre){
													cont++
									} else {
										if(estatus == 'Bloqueados' && cursos.cursosNombres == infoAlumno.cursoNombre) {
												if(alumnosBloqueados.includes(infoAlumno.matricula)){
													cont++
												}
										}
									}
							}
							contCursos.push(cont)
					}
						estatusInfo.push({label: estatus, data: contCursos, backgroundColor: colores[estatus], stack: 1 })
				}
			
			const cursosInfo = []
			for (const cursos of data.cursos) {
				cursosInfo.push(cursos.cursosNombres)
			}
			const graficaMisCursos = {
						labels: cursosInfo,
						datasets: estatusInfo
			}
			this.setState({dataGraficaMisCursos: graficaMisCursos, alumnosInfo: alumnosInfo, alumnosInfoEstatus: alumnosInfoEstatus, alumnosBloqueados: alumnosBloqueados, cursos: data.cursos})

		}
		
		tablaMisCursos = (data) => {
			const cursosInfo = data.cursos

			const alumnosInfoEstatus = this.state.alumnosInfoEstatus

			const grupos = []
			for (const alumnosInfo of this.state.alumnosInfo) {
				grupos.push(alumnosInfo.grupo)
			}
			const gruposInfo = this.eliminaDuplicados(grupos)

			const alumnosBloqueados = this.state.alumnosBloqueados

			const dataTablaMisCursos = []
			const estatusConteo = {}
			
			let alumnosGrupo = null;
			const docenteInfo = JSON.parse(localStorage.getItem('profile'));
			for (const cursos of cursosInfo) {
				for (const grupo  of gruposInfo) {
						const estatusConteo = {}
						let estatusDetalles = {}
						let bloqueados = 0
						let estudiantes = 0
							for (const alumnos of this.state.alumnosInfo) {
										if(alumnos.grupo == grupo && alumnos.cursoNombre == cursos.cursosNombres){
											estudiantes++
												if(alumnosInfoEstatus.includes(alumnos.estatus)){
													alumnosGrupo = alumnos.grupo
														if(alumnosBloqueados.includes(alumnos.matricula)){ bloqueados++ } 
														
														if(this.objectSize(estatusConteo) > 0){
															if(estatusConteo[alumnos.estatus] === undefined) {
																	const addEstatus =  alumnos.estatus
																	const estatus =  { [addEstatus] : 1 }
																	estatusDetalles = Object.assign(estatusConteo, estatus)
															} else {
																let cont = estatusConteo[alumnos.estatus]
																cont++
																delete estatusConteo[alumnos.estatus]
																const estatus =  { [alumnos.estatus] : cont }
																estatusDetalles = Object.assign(estatusConteo, estatus)
															}
														} else {
																const estatus =  { [alumnos.estatus] : 1 }
																estatusDetalles = Object.assign(estatusConteo, estatus)
														}

												}
										}
							}
							let estatusFaltantes = {}
							let unficarEstatusFaltantes = {}
							for (const estatus of this.state.alumnosInfoEstatus) {
								if(estatusDetalles[estatus] === undefined && estatus != 'Bloqueados') {
									const estatusInfo =  { [estatus] : 0 }
									unficarEstatusFaltantes = Object.assign(estatusFaltantes, estatusInfo)
								}
							}
							// let nivel  = cursos.nivel === 'lic' ? 'Licenciatura' : cursos.nivel === 'mtr' ? 'Maestría' : 'Doctorado'  ;
							let nivel = ''
							if(cursos.nivel == 'lic') {
								nivel = 'Licenciatura'
							} else if(cursos.nivel == 'mtr') {
								nivel = 'Maestría'
							} else if(cursos.nivel == 'doc') {
								nivel = 'Doctorado'
							} else if(cursos.nivel == 'onsite') {
								nivel = 'Onsite'
							}

							const dataObject = { 
											curso:  cursos.cursosNombres, 
											url_curso: 'https://'+cursos.nivel+'.ieu.edu.mx/course/view.php?id=' + cursos.cursosId, 
											nivel: nivel,
											grupo: alumnosGrupo, 
											estudiantes: estudiantes, 
											Bloqueados: bloqueados, 
								}
							const estatusFinal = Object.assign(dataObject, estatusDetalles,  unficarEstatusFaltantes)
							if(estudiantes > 0){
								dataTablaMisCursos.push(estatusFinal)
							}
					}
			}
			this.setState({dataTablaMisCursos: dataTablaMisCursos})
		}

		getDateUnix = (unixDate) => {
			const milliseconds = unixDate * 1000
			const date = new Date(milliseconds);
			const options = {
					year: "numeric",
					month: "2-digit",
					day: "2-digit"
			};
			return date.toLocaleDateString( undefined, options )
		}
		
		eliminaDuplicados = (arr) => {
			return arr.reduce( (accArr, valor) => {
				if (accArr.indexOf(valor) < 0) {
					accArr.push(valor);
				}
				return accArr;
			}, []);
		}

		randNumber = () => {
			const rndInt = Math.floor(Math.random() * 255) + 1
			return rndInt
		}

		objectSize = (obj) => {
			var size = 0,
				key;
			for (key in obj) {
				if (obj.hasOwnProperty(key)) size++;
			}
			return size;
		};

		handleClick = (curso, grupo) => {
			this.setState({statusDataTablaCurso: true, loadingTablaCurso: 'active'})
			const alumnosInfo = this.state.alumnosInfo
			const dataTablaCurso = []
			let cursoId = '';
			const cursosInfo = this.state.cursos;
			
			for (const cursos of cursosInfo) {
				if(cursos.cursosNombres == curso) {
					cursoId = cursos.cursosId 
				}
			}
			for (const alumnos of alumnosInfo) {
				if(alumnos.cursoNombre == curso && alumnos.grupo == grupo){
					// let nivel = alumnos.nivel === 'Licenciatura' ? 'lic' : alumnos.nivel === 'Maestría' ? 'mtr' : 'doc';
					let nivel = ''
					if(alumnos.nivel == 'Licenciatura') {
						nivel = 'lic'
					} else if(alumnos.nivel == 'Maestría') {
						nivel = 'mtr'
					} else if(alumnos.nivel == 'Doctorado') {
						nivel = 'doc'
					} else if(alumnos.nivel == 'Onsite') {
						nivel = 'onsite'
					}
					dataTablaCurso.push({
						matricula: alumnos.matricula, 
						url_matricula: 'https://' + alumnos.urlNivel + '.ieu.edu.mx/user/view.php?id=' + alumnos.id +'&course=' + cursoId, 
						nombre: alumnos.nombres, 
						apellidos: alumnos.apellidos, 
						email: alumnos.email, 
						nivel: alumnos.nivel, 
						grupo: alumnos.grupo, 
						ultimo_acceso: alumnos.ultimoAcceso, 
						status: alumnos.estatus 
					})
				}
			}
			
			this.setState({dataTablaCurso: dataTablaCurso, titleCurso: curso, loadingTablaCurso: '' })
		}

	render(){
		return (
			<>
				{ this.state.vistaGeneral === true ? (
					<Dimmer loader active={this.state.loading} >
						<GraficaMisCursos data={this.state} />
					</Dimmer>
				):(
					<Page.Content className="page-mis-cursos">
							<Page.Title><Icon prefix="fe" name="book" /> Mis Cursos</Page.Title>
							<Card className="card-div" title="Gráfica Mis Cursos" isCollapsible isFullscreenable>
						<Card.Body>
							<Dimmer loader active={this.state.loading} >
								<GraficaMisCursos data={this.state} />
							</Dimmer>
						</Card.Body>
					</Card>
					<Card className="card-div card-tabla-mis-cursos" title="Tabla Mis Cursos" isCollapsible isFullscreenable>
						<Card.Body>
							<Dimmer loader active={this.state.loading} >
								<TablaMisCursos data={this.state} parentCallBack={this.handleClick} />
							</Dimmer>
						</Card.Body>
					</Card>
					<div id="tablaCurso">
						{this.state.statusDataTablaCurso && 
						<Card className="card-div card-tabla-mis-cursos" title={this.state.titleCurso} /*isClosable*/ isCollapsible isFullscreenable>
							<Card.Body>
								<Dimmer loader active={this.state.loadingTablaCurso}>
									<TablaCurso data={this.state} />
								</Dimmer>
							</Card.Body>
						</Card>}
					</div>
					</Page.Content>
				)
				}
					
			</>
		);
	}
}

export default MisCursos;